export default "__VITE_ASSET__BRVIROIz__"